import initializePickers, { EnumPickerType } from '../plugins/PluginPicker'
import Swiper from 'swiper'

window.addEventListener('load', () => {
  initializePickers({
    picker: {
      type: EnumPickerType.SINGLE,
      selector: '[data-picker="tab"]',
    },
    buttonSelector: '[data-picker-btn="tab"]',
    itemSelector: '[data-picker-item="tab"]',
    activeIndexes: [],
    noSelected: true,
    activeClass: 'active',
    onInit: (state) => {
      const scrollToElement = (el: Element) => {
        const rect = el.getBoundingClientRect()
        const offset = rect.top + window.scrollY - 300

        window.scrollTo({
          top: offset,
          behavior: 'smooth',
        })
      }
      setTimeout(() => {
        const item = state.element.querySelector<Element>(
          '[data-picker-item="tab"].active',
        )

        if (!item) return

        scrollToElement(item)
      }, 500)
    },
    onStateChange: (state) => {
      const scrollToElement = (el: Element) => {
        const rect = el.getBoundingClientRect()
        const offset = rect.top + window.scrollY - 300

        window.scrollTo({
          top: offset,
          behavior: 'smooth',
        })
      }

      if (!state.activeIndexes.length) {
        scrollToElement(state.element)
        return
      }

      const index = state.activeIndexes[0]
      const item = state.element.querySelectorAll<Element>(
        '[data-picker-item="tab"]',
      )[index]

      if (!item) return

      scrollToElement(item)
    },
  })

  const dancerPage = document.querySelector('[data-page="dancer"]')

  let dancerIndex = 0
  if (dancerPage) {
    console.log(dancerPage)

    const id = new URLSearchParams(window.location.search).get("id");
    const dancers = document.querySelectorAll('[data-dancer-id]')

    console.log(id)
    dancers.forEach((dancer, index) => {
      if (dancer.getAttribute('data-dancer-id') === id) {
        dancerIndex = index
      }

      return
    })

  }

  initializePickers({
    picker: {
      type: EnumPickerType.SINGLE,
      selector: '[data-picker="offer-category"]',
    },
    buttonSelector: '[data-picker-btn]',
    itemSelector: '[data-picker-item]',
    activeIndexes: [dancerIndex],
    noSelected: false,
    activeClass: 'active',
    onInit: (state) => {
      const scrollToElement = (el: Element) => {
        const rect = el.getBoundingClientRect()
        const offset = rect.top + window.scrollY - 300

        window.scrollTo({
          top: offset,
          behavior: 'smooth',
        })
      }
      setTimeout(() => {
        const item = state.element.querySelector<Element>(
          '[data-picker-btn].active',
        )

        if (!item) return

        if (dancerIndex > 0)
          scrollToElement(item)
      }, 500)
    },
  })

  // EXAMPLES:
  // initializePickers({
  //   picker: {
  //     type: EnumPickerType.SINGLE,
  //     selector: '[data-picker="picker"]',
  //   },
  //   buttonSelector: '[data-picker-btn]',
  //   itemSelector: '[data-picker-item]',
  //   activeIndexes: [0],
  //   noSelected: true,
  //   activeClass: 'active',
  // })

  // initializePickers({
  //   picker: {
  //     type: EnumPickerType.MULTIPLE,
  //     selector: '[data-picker-multiple="picker"]',
  //   },
  //   buttonSelector: '[data-picker-btn]',
  //   itemSelector: '[data-picker-item]',
  //   activeIndexes: [0, 1],
  //   noSelected: true,
  //   activeClass: 'active',
  // })

  // initializePickers({
  //   picker: {
  //     type: EnumPickerType.CATEGORY,
  //     selector: '[data-picker="category"]',
  //     categoryAttribute: 'data-picker-category',
  //   },
  //   buttonSelector: '[data-picker-btn]',
  //   itemSelector: '[data-picker-item]',
  //   activeIndexes: [0],
  //   noSelected: false,
  //   activeClass: 'active',
  //   onInit: (state) => {},
  //   onStateChange: (state) => {},
  // })
  initializePickers({
    picker: {
      type: EnumPickerType.SINGLE,
      selector: '[data-picker="offer-other"]',
    },
    buttonSelector: '[data-picker-offer-other-btn]',
    itemSelector: '[data-picker-offer-other-item]',
    activeIndexes: [],
    noSelected: true,
    activeClass: 'active',
    onStateChange: (state) => {
      console.log('state', state)
      const items = state.element.querySelectorAll(
        '[data-picker-offer-other-btn]',
      )
      const contentItems = state.element.querySelectorAll(
        '[data-picker-offer-other-item]',
      )
      const contentBtns = state.element.querySelectorAll(
        '[data-picker-offer-other-btn]',
      )

      if (contentItems?.[state.activeIndexes[0]]) {
        state.element.setAttribute(
          'data-active-index',
          String(state.activeIndexes[0] ?? -1),
        )
        // const backBtn = contentItems?.[state.activeIndexes[0]].querySelector(
        //   '[data-hide-picker]',
        // )

        // console.log('backBtn', backBtn)
        // if (backBtn) {
        //   backBtn.addEventListener('click', (e) => {
        //     console.log('click')
        //     if (contentBtns?.[state.activeIndexes[0]]) {
        //       contentBtns?.[state.activeIndexes[0]].click()
        //     }
        //   })
        // }

        // contentItems.forEach((item) => {

        const swiperEl = contentItems?.[state.activeIndexes[0]].querySelector(
          '[data-slider="offer-other-content"]',
        )

        const swiper = new Swiper(swiperEl, {
          slidesPerView: 1,
          watchSlidesProgress: true,
          slidesPerGroup: 1,
          spaceBetween: 10,
          speed: 300,
          // loop: true,
          initialSlide: 1,
          breakpoints: {
            992: {
              slidesPerView: 2,
            },
          },
        })
        // swiper.update();
        // })
      }
    },
  })
})
document.addEventListener('click', (e) => {
  const backBtn = (e.target as HTMLElement).closest('[data-hide-picker]')
  if (backBtn) {
    const picker = backBtn.closest('[data-picker="offer-other"]')
    if (!picker) return

    const activeIndex = Number(picker.getAttribute('data-active-index'))
    const btns = picker.querySelectorAll('[data-picker-offer-other-btn]')
    btns[activeIndex]?.click()
  }
})
